export const INSTRUCTIONS_URL =
	'https://eitjehq.notion.site/Vestiging-verplaatsen-van-organisatie-splitsen-183df7656b548016bfabe3965f376cc8'
